<template>
  <div class="product">
    <div class="box1">
      <div class="w">
        <el-row>
          <el-col :span="12">
            <div class="col-r">
              <!-- 标题 -->
              <div class="h1">
                <strong
                  >{{ data.productModel }} {{ getText(data, "title") }}</strong
                >
              </div>
              <!-- 副标题 -->
              <div class="h2">{{ getText(data, "subtitle") }}</div>
              <!-- 产品描述 -->
              <div class="p">
                {{ getText(data, "productDesc") }}
              </div>
              <!-- <div class="p">
                {{ getText(data, "productDeliveryTime") }}
              </div> -->
              <div class="imgs" v-if="data.pictureList">
                <div
                  class="imgBox video"
                  @click="dialogVisible = true"
                  v-if="data.video"
                >
                  <img :src="data.pictureList[0]" alt="" />
                  <div class="bf">
                    <i class="el-icon-caret-right"></i>
                  </div>
                </div>

                <div
                  class="imgBox"
                  v-for="(item, index) in data.pictureList"
                  :key="index"
                  @click="
                    data.picture = item;
                    activeImg = false;
                  "
                >
                  <img :src="item" alt="" />
                </div>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <img
              class="bigImg"
              v-if="data.pictureList"
              :src="data.picture"
              alt="s"
            />
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="box2">
      <div class="w">
        <div class="title">{{ $t("product.technology") }}</div>
        <ul class="imgs">
          <a
            v-if="data.productSpecification"
            :href="data.productSpecification"
            target="_blank"
            download="产品手册-说明书.pdf"
            title="产品手册-说明书"
          >
            <img :src="require('../assets/svg/产品手册-说明书.svg')" alt="" />
          </a>
          <a
            v-if="data.cecertification"
            :href="data.cecertification"
            target="_blank"
            download="CE认证.pdf"
            title="CE认证"
          >
            <img :src="require('../assets/svg/CE认证.svg')" alt="" />
          </a>
          <a
            v-if="data.pfacertification"
            :href="data.pfacertification"
            target="_blank"
            download="PFA.pdf"
            title="PFA"
          >
            <img :src="require('../assets/svg/PFA.svg')" alt="" />
          </a>
          <a
            v-if="data.silcertification"
            :href="data.silcertification"
            target="_blank"
            download="SIL认证.pdf"
            title="SIL认证"
          >
            <img :src="require('../assets/svg/SIL认证.svg')" alt="" />
          </a>
          <a
            v-if="data.cqstcertification"
            :href="data.cqstcertification"
            target="_blank"
            download="防爆认证.pdf"
            title="防爆认证"
          >
            <img :src="require('../assets/svg/防爆认证.svg')" alt="" />
          </a>
          <a
            v-if="data.calibrationCertification"
            :href="data.calibrationCertification"
            target="_blank"
            download="校准认证.pdf"
            title="校准认证"
          >
            <img :src="require('../assets/svg/校准认证.svg')" alt="" />
          </a>
          <a
            v-if="data.patentCertification"
            :href="data.patentCertification"
            target="_blank"
            download="专利认证.pdf"
            title="专利认证"
          >
            <img :src="require('../assets/svg/专利认证.svg')" alt="" />
          </a>
        </ul>
        <el-row v-if="gettechnical()">
          <el-col
            :span="10"
            v-for="(item, index) in gettechnical()"
            :key="index"
          >
            <el-row>
              <el-col :span="8">{{ item.key }}</el-col>
              <el-col :span="16">{{ item.val }}</el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="box3">
      <div class="w">
        <div class="title">{{ $t("product.product") }}</div>
        <ul>
          <li v-for="(item, index) in data.productConfig" :key="index">
            <div v-if="item.label == '分割线'" class="divider-line"></div>

            <div class="configureName">
              <i class="el-icon-edit"></i> {{ getText(item.props, "title") }}
            </div>
            <div class="configureOption">
              <!-- 单行文本 -->
              <div class="div" v-if="item.label == '单行文本'">
                <el-row>
                  <el-col :span="4">
                    <el-input
                      v-model="item.isFinish"
                      :label="item.label"
                      :placeholder="
                        $i18n.locale === 'zh'
                          ? '请输入内容'
                          : 'Please enter the'
                      "
                    />
                  </el-col>
                </el-row>
              </div>
              <!-- 多行文本 -->
              <div class="div" v-if="item.label == '多行文本'">
                <el-row>
                  <el-col :span="4">
                    <el-input
                      type="textarea"
                      white-space="pre-line"
                      v-model="item.isFinish"
                      :label="item.label"
                      :placeholder="
                        $i18n.locale === 'zh'
                          ? '请输入内容'
                          : 'Please enter the'
                      "
                    />
                  </el-col>
                </el-row>
              </div>
              <!-- 级联选择 -->
              <div class="div" v-if="item.label == '级联选择'">
                <el-row>
                  <el-col :span="4">
                    <el-cascader
                      v-model="item.isFinish"
                      :placeholder="
                        $i18n.locale === 'zh' ? '请选择' : 'Please choose the'
                      "
                      :options="item.props.options"
                      :props="selectGProps"
                    >
                      <template slot-scope="{ data }">
                        <span>{{
                          $i18n.locale === "zh" ? data.label : data.labelEN
                        }}</span>
                      </template>
                    </el-cascader>
                  </el-col>
                </el-row>
              </div>
              <!-- 单选循环 -->
              <div class="div" v-if="item.label == '单选'">
                <el-row>
                  <el-col
                    :span="18"
                    v-for="i in item.props.options"
                    :key="i && i.value"
                  >
                    <el-radio
                      v-model="item.isFinish"
                      :label="i"
                      @click.native.prevent="clickitem(i, item)"
                    >
                      {{ i && ($i18n.locale === "zh" ? i.label : i.labelEN) }}
                      <span v-if="i.sup" :class="{ required: i.sup }">
                        {{ Array.isArray(i.sup) ? i.sup.join("") : i.sup }}
                      </span>
                    </el-radio>
                  </el-col>
                </el-row>
              </div>
              <div v-if="item.label == '分割线'" class="divider-line"></div>

              <!-- 多选 -->
              <div v-if="item.label == '多选'">
                <el-row>
                  <el-checkbox-group v-model="item.isFinish">
                    <el-col
                      :span="18"
                      v-for="i in item.props.options"
                      :key="i.value"
                    >
                      <el-checkbox :label="i">
                        {{ $i18n.locale === "zh" ? i.label : i.labelEN }}
                        <span v-if="i.sup" :class="{ required: i.sup }">
                          {{ Array.isArray(i.sup) ? i.sup.join("") : i.sup }}
                        </span>
                      </el-checkbox>
                    </el-col>
                  </el-checkbox-group>
                </el-row>
              </div>
              <!-- 子项单选 -->
              <div v-if="item.label == '子项单选'">
                <el-row>
                  <el-checkbox-group v-model="item.isFinish">
                    <el-col
                      :span="4"
                      v-for="i in item.props.options"
                      :key="i.value"
                    >
                      <el-radio v-model="item.isFinish" :label="i">
                        {{ $i18n.locale === "zh" ? i.label : i.labelEN }}
                        <span v-if="i.sup" :class="{ required: i.sup }">
                          {{ Array.isArray(i.sup) ? i.sup.join("") : i.sup }}
                        </span>
                      </el-radio>
                      <el-select
                        v-model="item.isFinish.value"
                        filterable
                        :placeholder="
                          $i18n.locale === 'zh' ? '请选择' : 'Please choose the'
                        "
                      >
                        <el-option
                          v-for="j in i.options"
                          :key="j.label"
                          :label="$i18n.locale === 'zh' ? j.label : j.labelEN"
                          :value="j.label"
                        >
                        </el-option>
                      </el-select>
                    </el-col>
                  </el-checkbox-group>
                </el-row>
              </div>
              <!-- 单选下拉框 -->
              <div v-if="item.label == '单选下拉框'">
                <el-row>
                  <el-col :span="4">
                    <el-select
                      v-model="item.isFinish"
                      filterable
                      :placeholder="
                        $i18n.locale === 'zh' ? '请选择' : 'Please choose the'
                      "
                    >
                      <el-option
                        v-for="i in item.props.options"
                        :key="i.value"
                        :label="$i18n.locale === 'zh' ? i.label : i.labelEN"
                        :value="i"
                      >
                        <span>
                          {{ $i18n.locale === "zh" ? i.label : i.labelEN }}
                          <span v-if="i.sup" :class="{ required: i.sup }">
                            {{ Array.isArray(i.sup) ? i.sup.join("") : i.sup }}
                          </span>
                        </span>
                      </el-option>
                    </el-select>
                  </el-col>
                </el-row>
              </div>

              <!-- 数字单选阶梯 -->
              <div v-if="item.label == '数字单选阶梯'">
                <el-row>
                  <el-checkbox-group v-model="item.isFinish">
                    <el-col
                      :span="4"
                      v-for="i in item.props.options"
                      :key="i.value"
                    >
                      <el-radio v-model="item.isFinish" :label="i">
                        {{ i && ($i18n.locale === "zh" ? i.label : i.labelEN) }}
                        <span v-if="i.sup" :class="{ required: i.sup }">
                          {{ Array.isArray(i.sup) ? i.sup.join("") : i.sup }}
                        </span>
                      </el-radio>
                    </el-col>
                  </el-checkbox-group>
                </el-row>
                <el-row>
                  <el-col :span="4">
                    <el-input
                      v-model="item.isFinish.inp"
                      :placeholder="
                        $i18n.locale === 'zh'
                          ? '请输入长度'
                          : 'Please enter the'
                      "
                    >
                    </el-input>
                  </el-col>
                </el-row>
              </div>
              <!-- 数字 -->
              <div v-if="item.label == '数字'">
                <el-row>
                  <el-col :span="4">
                    <el-input
                      clearable
                      v-model="item.isFinish"
                      :placeholder="
                        $i18n.locale === 'zh'
                          ? '请输入长度'
                          : 'Please enter the'
                      "
                    >
                    </el-input>
                  </el-col>
                </el-row>
              </div>
              <!-- 数字单选 -->
              <div v-if="item.label == '数字单选'">
                <el-row>
                  <el-checkbox-group v-model="item.isFinish">
                    <el-col
                      :span="4"
                      v-for="i in item.props.options"
                      :key="i.value"
                    >
                      <el-radio v-model="item.isFinish" :label="i">
                        {{ i && ($i18n.locale === "zh" ? i.label : i.labelEN) }}
                        <span v-if="i.sup" :class="{ required: i.sup }">
                          {{ Array.isArray(i.sup) ? i.sup.join("") : i.sup }}
                        </span>
                      </el-radio>
                    </el-col>
                  </el-checkbox-group>
                </el-row>
                <el-row>
                  <el-col :span="4">
                    <el-input
                      v-model="item.isFinish.inp"
                      :placeholder="
                        $i18n.locale === 'zh'
                          ? '请输入长度'
                          : 'Please enter the'
                      "
                    >
                    </el-input>
                  </el-col>
                </el-row>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="box4" @click="dayin()">
      <div class="gocard" @click="gocard()">{{ $t("product.myCart") }}</div>
      <div class="body">
        <div class="title">{{ $t("product.yourConfiguration") }}</div>
        <div class="pz">{{ $t("product.model") }}</div>
        <div class="sku">{{ peizhi().sku }}</div>
        <div class="choose-box">
          <el-row :gutter="30">
            <el-col :span="12">
              <div class="text">{{ $t("product.quantity") }}</div>
              <el-input-number
                size="mini"
                :precision="0"
                :min="0"
                :step="1"
                v-model="actionNumber"
                style="width: 100%"
              />
            </el-col>
            <el-col :span="12">
              <div class="text">{{ $t("product.price") }}</div>
              <strong
                v-if="this.peizhi().price != 0 && this.data.price"
                style="color: rgb(43, 57, 68); font-size: 1.15rem"
                >￥{{ (peizhi().price * actionNumber).toFixed(2) }}
              </strong>
              <!-- <strong v-if="item.price!=0">

                </strong> -->
            </el-col>
          </el-row>
        </div>
      </div>
      <div class="footer">
        <el-row>
          <el-col :span="12">
            <div class="but" @click="addCart()">
              <i class="el-icon-shopping-cart-full"></i>
              <!-- <img  @click="addCart()" src="../assets/images/card.png" alt=""> -->
              {{ $t("product.join") }}
            </div>
          </el-col>
          <el-col :span="12">
            <div class="tips">
              <div class="info">{{ $t("product.special") }}</div>
              <div class="tel">400-778-0918</div>
            </div>
          </el-col>
        </el-row>
      </div>
      <!-- <div class="jg">
        <strong style="color: rgb(43, 57, 68); font-size: 1.25rem"
          >价格:{{ (peizhi().price * actionNumber).toFixed(2) }}</strong
        >

        <br />
        <div>
          <br />
          <div class="but" @click="addCart()">
            <i class="el-icon-shopping-cart-full"></i>
            加入购物车
          </div>
        </div>
      </div>
      特殊需求： 400-778-0918 -->
    </div>

    <el-dialog
      title="视频播放"
      v-if="dialogVisible"
      :visible.sync="dialogVisible"
      width="50%"
    >
      <video
        autoplay
        name="video"
        style="width: 100%"
        :src="data.video"
      ></video>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisible = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Store from "../store";
import { getLang } from "../plugins/common";

// console.log(window.localStorage)
// console.log(window.location)
// console.log(window.locationbar)
// console.log(cookies)
// let arr = document.cookie.split('; ');
// console.log(arr)
// console.log(document.cookie)
export default {
  data() {
    return {
      inputDigit: null,
      dialogVisible: false,
      store: Store.state,
      activeImg: false,
      radioKey: false,
      radioVal: "",
      radio: "",
      //
      selectGProps: {
        label: this.$i18n.locale === "zh" ? "label" : "labelEN",
      },
      imgs: [
        "http://183.194.66.54:8081/Resource/Import/2021/06/01/292b3238a5bf4915ab92b51538b1e5ca.png",
        "http://183.194.66.54:8081/Resource/Import/2021/05/31/d3b69a113ed149d29d3f3b87d018ae9c.png",
        "http://183.194.66.54:8081/Resource/Import/2021/06/01/0a25ecdf3a85406d97bbb58ef950c9e3.png",
      ],
      // 技术参数
      technicalParameters: [
        // {
        //   key: "测量范围",
        //   val: "-0.1~70.0MPa",
        // },
        // {
        //   key: "螺纹规格",
        //   val: "1/4NPT内螺纹 ，可约定",
        // },
        // {
        //   key: "法兰规格",
        //   val: "DN25 可约定",
        // },
        // {
        //   key: "环境温度",
        //   val: "-25~85℃",
        // },
        // {
        //   key: "连接方式",
        //   val: "SUS316L， SUS316L喷涂PTFE ，钽 ，哈C， 哈C喷涂PTFE ，蒙乃尔 ，钛合金",
        // },
        // {
        //   key: "卡盘规格",
        //   val: "-25~85℃ -40~125℃",
        // },
        // {
        //   key: "连接材质",
        //   val: "正表压 负表压 绝压",
        // },
        // {
        //   key: "信号类型",
        //   val: "两线4~20mA， 两线4~20mA带HART， RS485/Modbus Rtu ，三线1~5V ，可约定",
        // },
        // {
        //   key: "防护等级",
        //   val: "IP65",
        // },
        // {
        //   key: "是否带显示",
        //   val: "LCD数字显示 ，可约定",
        // },
      ],
      // 产品配置
      configure: [
        {
          // 配置类型
          name: "",
          // 选中的配置
          activeVal: "",
          // 配置选项(单选)
          valList: [
            {
              label: "螺纹",
              val: "1",
            },
            {
              label: "法兰",
              val: "2",
            },
            {
              label: "双法兰",
              val: "3",
            },
            {
              label: "用户约定",
              val: "4",
            },
          ],
          // 配置选项(多选)
          valSelectList: [
            {
              list: [
                {
                  value: "1",
                  label: "黄金糕",
                  label2: "黄金糕",
                },
                {
                  value: "2",
                  label: "双皮奶",
                  label2: "双皮奶",
                },
                {
                  value: "3",
                  label: "蚵仔煎",
                  label2: "双皮奶",
                },
                {
                  value: "4",
                  label: "龙须面",
                  label2: "双皮奶",
                },
                {
                  value: "7",
                  label: "北京烤鸭",
                  label2: "双皮奶",
                },
              ],
            },
          ],
        },
      ],

      data: {
        // categoryId: 0, //  	类目id	integer(int64)
        // configTemplateId: 0, //  	配置模板id	integer(int64)
        // createTime: "", //  	创建时间	string(date-time)
        id: 0, //  	id	integer(int64)
        // isShelves: false, //  	是否上架	boolean
        picture: "", //  	图片	string
        pictureList: [], //  	图片列表	array	string
        // 认证列表
        certificationList: [],
        price: 0, //  	产品价格	number
        productConfig: [], //  	产品配置	string
        productDesc: "", //  	产品描述	string
        // productInformation: "", //  	产品资料	string
        productModel: "", //  	产品型号	string
        // productSpecification: "", //  	产品说明书	string
        subtitle: "", //  	副标题	string
        technicalParameters: "", //  	技术参数	string
        technicalParametersEn: "", //技术参数 英文
        title: "", //  	产品标题	string
        // video: "", //  	视频
      },

      // 选择的配置
      zdyConfig: {},

      actionNumber: 1,
      activeConfig: {},
      productConfig: [],
      cascade: [],
    };
  },
  mounted() {
    // document.addEventListener("keydown", function(e) {
    //   if (e.key === "F12" || e.keyCode === 123) {
    //     e.preventDefault();
    //   }
    // });
    // document.addEventListener("contextmenu", function(e) {
    //   e.preventDefault();
    // });

    this.init(this.$route.query.productId);
    // this.init(2);
    // console.log(this.store);
    window.mydata = this;
  },

  methods: {
    getCascade(data) {
      console.info(data, this.$i18n.locale, 123);
      let tempData = [...data];
      this.loopCascade(tempData);
      return tempData;
    },
    loopCascade(data) {
      if (data) {
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          let isZH = /[\u4E00-\u9FA5]/.test(element.label);
          let lang = this.$i18n.locale;
          if (!isZH && lang === "zh") {
            let temp = element.label;
            element.label = element.labelEN;
            element.labelEN = temp;
          }
          if (isZH && lang === "en") {
            let temp = element.label;
            element.label = element.labelEN;
            element.labelEN = temp;
          }
          this.loopCascade(element.options);
        }
      } else return;
    },
    getText(parntProp, prop) {
      return getLang(this.$i18n.locale, parntProp, prop);
    },
    dayin() {
      console.log(this.peizhi());
    },
    // 获取选中的配置
    peizhi() {
      let sku = this.data.productModel || "";
      let price = this.data.price;
      if (!this.data.productConfig) {
        return {
          sku: sku,
          price: price,
        };
      }
      for (let i = 0; i < this.data.productConfig.length; i++) {
        if (typeof this.data.productConfig[i].isFinish == "object") {
          // console.log(this.data.productConfig[i].isFinish);
          if (this.data.productConfig[i].label == "单选") {
            if (this.data.productConfig[i].isFinish.sku)
              sku += `${this.data.productConfig[i].isFinish.sku}`;
            // sku+=`-${this.data.productConfig[i].isFinish.sku || ""}`
            price += Number(this.data.productConfig[i].isFinish.price) || 0;
          }
          if (this.data.productConfig[i].label == "级联选择") {
            //TODO
            // console.log(this.data.productConfig[i]);
            this.data.productConfig[i].isFinish.map((valueIitems, ind) => {
              // console.log(valueIitems);
              if (typeof valueIitems == "string") {
                this.data.productConfig[i].isFinish[ind] = JSON.parse(
                  valueIitems
                );
              }
            });
            sku += `${this.data.productConfig[i].isFinish[
              this.data.productConfig[i].isFinish.length - 1
            ].sku || ""}`;
            let p =
              (this.data.productConfig[i].isFinish[
                this.data.productConfig[i].isFinish.length - 1
              ].price &&
                Number(
                  this.data.productConfig[i].isFinish[
                    this.data.productConfig[i].isFinish.length - 1
                  ].price
                )) ||
              0;
            console.log(
              this.data.productConfig[i].isFinish[
                this.data.productConfig[i].isFinish.length - 1
              ].label
            );
            console.log(p);
            price += p;
          }
          if (this.data.productConfig[i].label == "子项单选") {
            if (this.data.productConfig[i].isFinish.sku)
              sku += `${this.data.productConfig[i].isFinish.sku}`;
            // sku += `-${this.data.productConfig[i].isFinish.sku || ""}`;
            let p = 0;
            let x =
              (this.data.productConfig[i].isFinish.inp &&
                Number(this.data.productConfig[i].isFinish.inp)) ||
              0;
            for (
              let j = 0;
              j < this.data.productConfig[i].isFinish.options.length;
              j++
            ) {
              if (
                this.data.productConfig[i].isFinish.options[j].label ==
                this.data.productConfig[i].isFinish.value
              ) {
                p =
                  (this.data.productConfig[i].isFinish.options[j].price &&
                    Number(
                      this.data.productConfig[i].isFinish.options[j].price
                    )) ||
                  0;
              }
            }
            price += p * x;
          }
          if (this.data.productConfig[i].label == "单选下拉框") {
            // console.log(this.data.productConfig[i]);
            if (this.data.productConfig[i].isFinish.sku)
              sku += `${this.data.productConfig[i].isFinish.sku}`;
            // sku+=`-${this.data.productConfig[i].isFinish.sku || ""}`
            let p = 0;
            let x =
              (this.data.productConfig[i].isFinish.inp &&
                Number(this.data.productConfig[i].isFinish.inp)) ||
              0;

            p =
              (this.data.productConfig[i].isFinish.price &&
                Number(this.data.productConfig[i].isFinish.price)) ||
              0;
            price += p + x;
          }

          if (this.data.productConfig[i].label == "数字单选") {
            if (this.data.productConfig[i].isFinish.inp)
              sku += `${this.data.productConfig[i].isFinish.inp}`;
            // sku += this.data.productConfig[i].isFinish.inp || "";
            // sku+=`-${this.data.productConfig[i].isFinish.inp || ""}`
            let x =
              (this.data.productConfig[i].isFinish.inp &&
                Number(this.data.productConfig[i].isFinish.inp)) ||
              0;
            // 基准
            let p =
              (this.data.productConfig[i].isFinish.price &&
                Number(this.data.productConfig[i].isFinish.price)) ||
              0;
            price += p * x;
          }
          if (this.data.productConfig[i].label == "数字单选阶梯") {
            if (this.data.productConfig[i].isFinish.inp)
              sku += `-${this.data.productConfig[i].isFinish.inp}`;
            // sku += this.data.productConfig[i].isFinish.inp || "";
            let x =
              (this.data.productConfig[i].isFinish.inp &&
                Number(this.data.productConfig[i].isFinish.inp)) ||
              0;
            // 基准
            let a =
              (this.data.productConfig[i].isFinish.base &&
                Number(this.data.productConfig[i].isFinish.base)) ||
              0;
            // 小于
            let b =
              (this.data.productConfig[i].isFinish.ltBase &&
                Number(this.data.productConfig[i].isFinish.ltBase)) ||
              0;
            // 大于
            let c =
              (this.data.productConfig[i].isFinish.geBase &&
                Number(this.data.productConfig[i].isFinish.geBase)) ||
              0;
            // 附加
            let d =
              (this.data.productConfig[i].isFinish.addBase &&
                Number(this.data.productConfig[i].isFinish.addBase)) ||
              0;
            // 计算
            let p;
            if (x <= a) {
              // console.log("小于等于");
              p = x * b;
              // console.log(config.price);
            } else {
              // console.log("大于");
              p = x * b + ((x - a) * c + d);
              // console.log(config.price);
            }

            price += p;
          }

          if (this.data.productConfig[i].label == "多选") {
            for (
              let j = 0;
              j < this.data.productConfig[i].isFinish.length;
              j++
            ) {
              if (this.data.productConfig[i].isFinish.sku)
                sku += `${this.data.productConfig[i].isFinish.sku}`;
              // sku += this.data.productConfig[i].isFinish[j].sku || "";
              // sku +=`-${this.data.productConfig[i].isFinish[j].sku || ""}`
              price += Number(this.data.productConfig[i].isFinish[j].price);
            }
            // console.log("duo");
          }
        }
        // console.log(this.data.productConfig[i])
        if (this.data.productConfig[i].label == "单行文本") {
          // console.log(this.data.productConfig[i]);
          price += 0;
        }
        if (this.data.productConfig[i].label == "多行文本") {
          // console.log(this.data.productConfig[i]);
          price += 0;
        }

        // 如果是 单数字阶梯
        if (this.data.productConfig[i].label == "数字") {
          if (this.data.productConfig[i].isFinish)
            sku += `${this.data.productConfig[i].isFinish}`;
          const input = this.data.productConfig[i].isFinish;
          if (this.inputDigit != null) {
            const parts = input.split("-");
            if (parts.length == 2) {
              const num1 = parts[0];
              const num2 = parts[1];
              this.inputDigit = Math.max(num1, num2);
            }
          }
          let x =
            (this.data.productConfig[i].isFinish &&
              (this.inputDigit !== null && this.inputDigit !== undefined
                ? Number(this.inputDigit)
                : Number(this.data.productConfig[i].isFinish))) ||
            0;
          // 基准
          let a =
            (this.data.productConfig[i].props.base &&
              (this.inputDigit !== null && this.inputDigit !== undefined
                ? Number(this.inputDigit)
                : Number(this.data.productConfig[i].props.base))) ||
            0;
          // 小于
          let b =
            (this.data.productConfig[i].props.ltBase &&
              (this.inputDigit !== null && this.inputDigit !== undefined
                ? Number(this.inputDigit)
                : Number(this.data.productConfig[i].props.ltBase))) ||
            0;
          // 大于
          let c =
            (this.data.productConfig[i].props.geBase &&
              (this.inputDigit !== null && this.inputDigit !== undefined
                ? Number(this.inputDigit)
                : Number(this.data.productConfig[i].props.geBase))) ||
            0;
          // 附加
          let d =
            (this.data.productConfig[i].props.addBase &&
              (this.inputDigit !== null && this.inputDigit !== undefined
                ? Number(this.inputDigit)
                : Number(this.data.productConfig[i].props.addBase))) ||
            0;

          let p;
          if (x <= a) {
            // console.log("小于等于");
            p = x * b;
            // console.log(config.price);
          } else {
            // console.log("大于");
            p = x * b + ((x - a) * c + d);
          }
          price += p;
        }
      }
      return {
        sku: sku,
        price: price,
      };
    },
    // 获取选中的配置
    peizhiConfig() {
      let productConfig = [];
      let config = {
        label: "",
        price: 0,
        value: "",
      };
      console.log(this.data.productConfig);
      for (let i = 0; i < this.data.productConfig.length; i++) {
        // this.productConfig = []
        if (typeof this.data.productConfig[i].isFinish == "object") {
          // console.log("1");
          // console.log(this.data.productConfig[i].props.title);
          // console.log(this.data.productConfig[i].isFinish);
          if (this.data.productConfig[i].label == "单选") {
            config.label = this.data.productConfig[i].props.title;
            config.price = this.data.productConfig[i].isFinish.price || 0;
            config.value = this.data.productConfig[i].isFinish.label;
            productConfig.push({
              label: config.label,
              price: config.price,
              value: config.value,
            });
          }

          if (this.data.productConfig[i].label == "多选") {
            for (
              let j = 0;
              j < this.data.productConfig[i].isFinish.length;
              j++
            ) {
              // if (config[this.data.productConfig[i].props.title]) {
              //   config[this.data.productConfig[i].props.title] = config[this.data.productConfig[i].props.title]+ ','+this.data.productConfig[i].isFinish[j].label;

              // }else{

              //   config[this.data.productConfig[i].props.title] = this.data.productConfig[i].isFinish[j].label;
              // }
              // console.log(this.data.productConfig[i].isFinish[j].label);
              config.label = this.data.productConfig[i].props.title;
              config.price = this.data.productConfig[i].isFinish[j].price;
              config.value = this.data.productConfig[i].isFinish[j].label;
              productConfig.push({
                label: config.label,
                price: config.price,
                value: config.value,
              });
            }
            // console.log("duo");
          }

          // 数字单选
          if (this.data.productConfig[i].label == "数字单选") {
            let x =
              (this.data.productConfig[i].isFinish.inp &&
                Number(this.data.productConfig[i].isFinish.inp)) ||
              0;
            // 基准
            let price =
              (this.data.productConfig[i].isFinish.price &&
                Number(this.data.productConfig[i].isFinish.price)) ||
              0;
            // 计算
            config.price = x * price;

            config.label = this.data.productConfig[i].props.title;
            // config.price = this.data.productConfig[i].isFinish.price || 0;
            config.value = this.data.productConfig[i].isFinish.label + " " + x;
            // config[this.data.productConfig[i].props.title] = this.data.productConfig[i].isFinish.label;
            productConfig.push({
              label: config.label,
              price: config.price,
              value: config.value,
            });
          }

          if (this.data.productConfig[i].label == "数字单选阶梯") {
            console.log("阶梯阶梯");
            let x =
              (this.data.productConfig[i].isFinish.inp &&
                Number(this.data.productConfig[i].isFinish.inp)) ||
              0;
            // 基准
            let a =
              (this.data.productConfig[i].isFinish.base &&
                Number(this.data.productConfig[i].isFinish.base)) ||
              0;
            // 小于
            let b =
              (this.data.productConfig[i].isFinish.ltBase &&
                Number(this.data.productConfig[i].isFinish.ltBase)) ||
              0;
            // 大于
            let c =
              (this.data.productConfig[i].isFinish.geBase &&
                Number(this.data.productConfig[i].isFinish.geBase)) ||
              0;
            // 附加
            let d =
              (this.data.productConfig[i].isFinish.addBase &&
                Number(this.data.productConfig[i].isFinish.addBase)) ||
              0;
            // 计算
            if (x <= a) {
              // console.log("小于等于");
              config.price = x * b;
              // console.log(config.price);
            } else {
              // console.log("大于");
              config.price = x * b + ((x - a) * c + d);
              // console.log(config.price);
            }

            config.label = this.data.productConfig[i].props.title;
            // config.price = this.data.productConfig[i].isFinish.price || 0;
            config.value = this.data.productConfig[i].isFinish.label + " " + x;
            // config[this.data.productConfig[i].props.title] = this.data.productConfig[i].isFinish.label;

            productConfig.push({
              label: config.label,
              price: config.price,
              value: config.value,
            });
          }

          if (this.data.productConfig[i].label == "子项单选") {
            // console.log('bbb');
            console.log(this.data.productConfig[i].isFinish);

            let x =
              (this.data.productConfig[i].isFinish.inp &&
                Number(this.data.productConfig[i].isFinish.inp)) ||
              0;
            let b =
              (this.data.productConfig[i].isFinish.price &&
                Number(this.data.productConfig[i].isFinish.price)) ||
              0;
            // // 计算
            config.price = x * b;
            //   console.log(config.price);

            config.label = this.data.productConfig[i].props.title;
            // if (this.data.productConfig[i].isFinish.inp<) {
            // }
            // config.price = this.data.productConfig[i].isFinish.inp;
            // console.log('1111111111111111111111');
            // console.log(this.data.productConfig[i].isFinish.value);
            config.value = this.data.productConfig[i].isFinish.value + " " + x;
            // config[this.data.productConfig[i].props.title] = this.data.productConfig[i].isFinish.label;

            productConfig.push({
              label: config.label,
              price: config.price,
              value: config.value,
            });
          }

          if (this.data.productConfig[i].label == "单选下拉框") {
            console.log(this.data.productConfig[i].isFinish);
            let x =
              (this.data.productConfig[i].isFinish.inp &&
                Number(this.data.productConfig[i].isFinish.inp)) ||
              0;
            let b =
              (this.data.productConfig[i].isFinish.price &&
                Number(this.data.productConfig[i].isFinish.price)) ||
              0;
            // // 计算
            config.price = x * b;
            config.label = this.data.productConfig[i].props.title;
            config.value = this.data.productConfig[i].isFinish.value + " " + x;
            productConfig.push({
              label: config.label,
              price: config.price,
              value: config.value,
            });
          }
          if (this.data.productConfig[i].label == "级联选择") {
            console.log(this.data.productConfig[i].isFinish);
            this.data.productConfig[i].isFinish.map((valueIitems, ind) => {
              console.log(valueIitems);
              if (typeof valueIitems == "string") {
                this.data.productConfig[i].isFinish[ind] = JSON.parse(
                  valueIitems
                );
              }
            });
            let b =
              (this.data.productConfig[i].isFinish[
                this.data.productConfig[i].isFinish.length - 1
              ].price &&
                Number(
                  this.data.productConfig[i].isFinish[
                    this.data.productConfig[i].isFinish.length - 1
                  ].price
                )) ||
              0;
            // // 计算
            config.price = b;
            config.label = this.data.productConfig[i].props.title;
            config.value = "";
            this.data.productConfig[i].isFinish.map((item, ind) => {
              if (ind + 1 == this.data.productConfig[i].isFinish.length) {
                config.value += item.label;
              } else {
                config.value += item.label + "/";
              }
            });

            productConfig.push({
              label: config.label,
              price: config.price,
              value: config.value,
            });
          }
        }

        if (this.data.productConfig[i].label == "单行文本") {
          // console.log(this.data.productConfig[i].isFinish);
          // // 计算
          config.label = this.data.productConfig[i].props.title;
          config.value = this.data.productConfig[i].isFinish;

          productConfig.push({
            label: config.label,
            price: 0,
            value: config.value,
          });
        }

        if (this.data.productConfig[i].label == "多行文本") {
          // console.log(this.data.productConfig[i].isFinish);
          // // 计算
          config.label = this.data.productConfig[i].props.title;
          config.value = this.data.productConfig[i].isFinish + " ";

          productConfig.push({
            label: config.label,
            price: 0,
            value: config.value,
          });
        }
        // 如果是 单数字阶梯
        if (this.data.productConfig[i].label == "数字") {
          // addBase: "5" 附加费
          // base: "10" 基准值
          // geBase: "10" 大于单价
          // ltBase: "5" 小于单价
          // sku: "sku"
          // title: "单数字阶梯"

          let x = Number(this.data.productConfig[i].isFinish);
          // 基准
          let a = Number(this.data.productConfig[i].props.base);
          // 小于
          let b = Number(this.data.productConfig[i].props.ltBase);
          // 大于
          let c = Number(this.data.productConfig[i].props.geBase);
          // 附加
          let d = Number(this.data.productConfig[i].props.addBase);
          if (x <= a) {
            // console.log("小于等于");
            config.price = x * b;
            // console.log(config.price);
          } else {
            // console.log("大于");
            config.price = x * b + ((x - a) * c + d);
          }

          config.value = x;
          config.label = this.data.productConfig[i].props.title;

          productConfig.push({
            label: config.label,
            price: config.price,
            value: config.value,
          });
          // }
        }
      }
      return {
        productConfig,
      };
    },
    gettechnical() {
      if (this.$i18n.locale == "zh") return this.technicalParameters;
      else return this.technicalParametersEn;
    },
    // 获取产品详情
    async init(id) {
      let { data: res } = await this.$http.get(`/c/product/get/${id}`);
      if (res.code !== 200) {
        return this.$message.error(res.message);
      }
      if (res.data.technicalParameters) {
        res.data.technicalParameters = this.stringToArray(
          res.data.technicalParameters
        );
        this.technicalParametersEn = res.data.technicalParametersEn
          ? this.stringToArray(res.data.technicalParametersEn)
          : [];
      }
      if (res.data.productConfig) {
        res.data.productConfig = JSON.parse(res.data.productConfig);
        console.info(res.data.productConfig, 1111111111);
        for (let i = 0; i < res.data.productConfig.length; i++) {
          if (res.data.productConfig[i].label == "多选") {
            res.data.productConfig[i].isFinish = [];
          }
          if (res.data.productConfig[i].label == "单选下拉框") {
            res.data.productConfig[i].isFinish =
              res.data.productConfig[i].props.options[0];
          }
          if (res.data.productConfig[i].label == "单行文本") {
            res.data.productConfig[i].isFinish = "";
          }
          if (res.data.productConfig[i].label == "多行文本") {
            res.data.productConfig[i].isFinish = "";
          }
          if (res.data.productConfig[i].label == "数字") {
            res.data.productConfig[i].isFinish = "";
          }
          if (res.data.productConfig[i].label == "级联选择") {
            res.data.productConfig[i].isFinish = "";
            const changeTree = (arr) => {
              arr.forEach((el) => {
                if (el.options) {
                  el.children = el.options;
                  el.oldValue = el.value;
                  el.value = JSON.stringify(el);
                  changeTree(el.options || []);
                } else {
                  el.children = el.options;
                  el.oldValue = el.value;
                  el.value = JSON.stringify(el);
                }
              });
            };
            if (res.data.productConfig[i].props.options) {
              changeTree(res.data.productConfig[i].props.options);
            }
          }
          // 确保 sup 属性的值类型一致
          if (res.data.productConfig[i].props.options) {
            res.data.productConfig[i].props.options.forEach((option) => {
              if (option.sup && typeof option.sup !== "string") {
                option.sup = option.sup.toString();
              }
            });
          }
        }
      }

      this.technicalParameters = res.data.technicalParameters;
      if (res.data.pictureList) {
        res.data.picture = res.data.pictureList[0];
      }
      this.data = res.data;
      window.mydata = this;
    },
    // 判断产品是否全选过 如果配置不够则返回true
    configIfAll() {
      let arr = [];
      // this.data.productConfig;
      for (let i = 0; i < this.data.productConfig.length; i++) {
        arr.push(this.data.productConfig[i].props.title);
      }
      // console.log(this.data.productConfig);
      let arr2 = [];
      let act = this.peizhiConfig().productConfig;
      console.log(act);
      // console.log(act);
      for (let i = 0; i < act.length; i++) {
        if (arr2.indexOf(act[i].label) == -1) {
          arr2.push(act[i].label);
        }
      }
      if (arr2.length == arr.length) {
        return false;
      } else {
        return true;
      }
    },
    aaopen() {
      this.$notify({
        title: "注意",
        message:
          "此产品后台配置交付天数为" + this.data.productDeliveryTime + "天",
        offset: 200,
        duration: 4000,
        type: "warning",
      });
    },
    // 加入购物车
    async addCart() {
      if (this.data.productDeliveryTime != null) {
        this.aaopen();
      }
      // if (this.configIfAll()) {
      //   return this.$message.error("需要选完配置");
      // }
      let { data: res } = await this.$http.put("/c/cart/add", {
        // 产品id
        productId: Number(this.data.id),
        // 产品数量
        productNumber: Number(this.actionNumber),
        // 产品配置
        productConfig: this.peizhiConfig().productConfig,

        productModel: this.peizhi().sku,

        productPrice: this.peizhi()?.price,
      });
      if (res.code != 200) {
        return this.$message.error(res.message);
      }
      // showClose: true,
      this.$message({
        offset: 80,
        showClose: true,
        message: "添加成功",
        type: "success",
      });
    },
    // 处理技术参数
    stringToArray(st) {
      let arr = st.split("\n");
      // console.log(st)
      let arrTwo = [];
      for (let i = 0; i < arr.length; i++) {
        //TODO
        // console.log(arrTwo)
        arrTwo.push({
          key: arr[i].substring(0, arr[i].indexOf("|")),
          val: arr[i].substring(arr[i].indexOf("|") + 1, arr[i].length),
        });
      }
      return arrTwo;
    },

    // 前往购物车
    // const : username = this.$store.state.user.name,

    clickitem(i, item) {
      // item.isFinish = item.isFinish.value === i.value ? i : "";
      item.isFinish.value === i.value
        ? (item.isFinish = "")
        : (item.isFinish = i);
      // if (this.aa === i.label) {
      //   // this.radio === i ? this.radio = '' : this.radio = i
      //   this.radio = this.radio === i ? i : '';
      // }
    },

    gocard() {
      if (window.sessionStorage.getItem("Authorization")) {
        this.$router.push("/personal/car");
      } else {
        this.$message.error("请先登录");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.product {
  .box1 {
    // height: 45.625rem;
    padding: 6.875rem;
    padding-bottom: 1.875rem;
    box-sizing: border-box;
    position: relative;
    .col-r {
      padding-left: 3.125rem;
    }
    .bigImg {
      height: 37.5rem;
      width: 37.5rem;
      max-width: 50.625rem;
    }
    video {
      height: 37.5rem;
      width: 42.4375rem;
      max-width: 50.625rem;
    }
    .h1 {
      font-size: 1.875rem;
      margin-top: 5rem;
    }
    .h2 {
      font-size: 1.25rem;
      margin: 1.875rem 0;
      color: #000;
      font-weight: 400;
    }
    .p {
      color: #999;
      height: 12rem;
      overflow-y: auto;
    }
    .imgs {
      // position: absolute;
      // bottom: 1.875rem;
      // left: calc(50% + 3.125rem);
      margin-top: 1.875rem;
      .imgBox {
        width: 5rem;
        height: 5rem;
        border-radius: 0.3125rem;
        border: 0.0625rem solid #fff;
        padding: 0.625rem;
        margin-right: 0.625rem;
        box-sizing: border-box;
        display: inline-block;
        img {
          width: 3.5rem;
          height: 3.5rem;
        }
      }
      .video {
        position: relative;

        .bf {
          position: absolute;
          border: 0.125rem solid #fff;
          border-radius: 50%;
          color: #fff;

          top: 50%;
          left: 50%;
          width: 2.5rem;
          transform: translate(-50%, -50%);
          font-size: 2.5rem;
          line-height: 2.5rem;
          height: 2.5rem;
          text-align: center;
        }
      }
      video {
        width: 5rem;
        height: 5rem;
        border-radius: 0.3125rem;
        border: 0.0625rem solid #fff;
        padding: 0.625rem;
        margin-right: 0.625rem;
        box-sizing: border-box;
        display: inline-block;
        transform: translateY(0.75rem);
      }
    }
  }
  .box2 {
    min-height: 31.875rem;
    background-color: rgb(44, 57, 68);
    padding-bottom: 1.875rem;
    .w {
      padding-top: 5.625rem;
      color: #fff;
      font-size: 0.875rem;
      line-height: 1.875rem;
      .el-col {
        // padding: .625rem;
        line-height: 3.125rem;
      }
      .imgs {
        img {
          width: 5rem;
          height: 5rem;
          margin-right: 0.9375rem;
        }
        img:hover {
          transform: scale(1.2);
        }
      }
    }
  }
  .box3 {
    // height: 44.375rem;
    margin-bottom: 1.875rem;
    .w {
      padding-top: 5.625rem;
      ul {
        li {
          line-height: 1.875rem;
          margin-bottom: 1.875rem;
          .configureName {
            height: 3.9375rem;
            line-height: 3.9375rem;
            font-size: 1.25rem;
            color: rgb(74, 186, 184);
            border-bottom: 0.0625rem solid rgb(74, 186, 184);
          }
          .configureOption {
            padding-top: 0.625rem;
            .el-col {
              margin-right: 4em;
            }
          }
        }
      }
    }
  }
  .required::before {
    // content: "*";
    color: red;
    margin-right: 4px;
  }

  .box2,
  .box3 {
    .w {
      position: relative;
    }
    .title {
      position: absolute;
      top: 0;
      color: #fff;
      text-align: center;
      line-height: 4.0625rem;
      left: 0;
      padding: 0 0.9375rem;
      // width: 10rem;
      height: 4.0625rem;
      font-size: 1.4375rem;
      border-radius: 0 0 0.625rem 0.625rem;
      background-color: rgb(97, 186, 184);
    }
  }
  .el-col-4 {
    width: 25%;
    min-width: 300px; /* 根据需要调整最小宽度 */
    max-width: 400px; /* 根据需要调整最大宽度 */
  }

  .box4 {
    position: fixed;
    right: 0;
    top: 30%;
    width: 18.75rem;
    // height: 15rem;
    z-index: 9;
    background-color: #fff;
    color: #333;
    box-sizing: border-box;
    border-radius: 0.9375rem 0 0 0.9375rem;
    box-shadow: -0.625rem 0 1.875rem rgba(0, 0, 0, 0.1);
    // padding: 1.25rem;
    line-height: 1.5625rem;
    font-size: 0.9375rem;
    overflow: hidden;

    .gocard {
      display: block;
      padding: 0.9375rem;
      text-align: center;
      background: rgb(245, 245, 245);
      font-size: 1rem;
    }
    .body {
      padding: 1.875rem;
      text-align: center;
      .title {
        font-size: 1.375rem;
        margin-bottom: 0.9375rem;
      }
      .pz {
        font-size: 1rem;
        margin-bottom: 0.9375rem;
      }
      .sku {
        font-size: 1.125rem;
        margin-bottom: 0.9375rem;
      }
      .choose-box {
        .text {
          font-size: 1.125rem;
          margin-bottom: 1.875rem;
        }
      }
    }

    .footer {
      .but {
        margin: 0;
        background-color: rgb(0, 171, 164);
        border-radius: 0;
        font-size: 1.125rem;
        padding: 0.625rem;
        cursor: pointer;
        i {
          position: relative;
          top: 0.3125rem;
        }
      }
      .tips {
        background-color: rgb(236, 236, 236);
        text-align: center;
        padding: 0.625rem;
        .tel {
          font-size: 1rem;
        }
      }
    }
    // .but {
    //   background-color: #fff;
    //   height: 1.875rem;
    //   line-height: 1.875rem;
    //   width: 80%;
    //   margin: .625rem auto;
    //   color: rgb(44, 57, 68);
    //   font-size: 1rem;
    //   i {
    //     font-size: 1rem;
    //   }
    // }
    .jg {
      margin: 2.1875rem 0;
    }
    .divider-line {
      width: 100%;
      height: 1px;
      background-color: #ddd;
      margin: 1rem 0;
    }
    img {
      width: 1rem;
      height: 1rem;
      transform: translateY(25%);
    }
    //  /deep/ .el-input-number__decrease{
    //   border-radius: 50%;
    // }
    // /deep/ .el-input-number{
    //   border-radius: .9375rem;
    // }
    .el-icon-shopping-cart-full {
      font-size: 1.875rem;
    }
  }
}
</style>
